import { useState, useEffect } from 'react';
import '../../css/shared/PhoneShell.css';
import AppHeader from './AppHeader';
import TabBar from './TabBar';
import SupportChat from './SupportChat';
import MenuScreen from '../menu/MenuScreen';
import BetSlipSheet, { BetSlipFab } from './BetSlipSheet';
import DesktopShell from '../desktop/DesktopShell';
import SearchOverlay from '../search/SearchOverlay';
import HomeFooter from '../home/HomeFooter';

function useIsDesktop() {
  const [desktop, setDesktop] = useState(() => window.innerWidth >= 1023);
  useEffect(() => {
    const handler = () => setDesktop(window.innerWidth >= 1023);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return desktop;
}

export default function PhoneShell({ activeTab, overlay, children }) {
  const isDesktop = useIsDesktop();
  const [menuOpen, setMenuOpen] = useState(false);
  const [slipOpen, setSlipOpen] = useState(false);
  const [betCount, setBetCount] = useState(0);

  useEffect(() => {
    const sync = () => setBetCount(JSON.parse(localStorage.getItem('betSlipItems') || '[]').length);
    sync();
    window.addEventListener('betAdded', sync);
    return () => window.removeEventListener('betAdded', sync);
  }, []);

  if (isDesktop) {
    return (
      <DesktopShell activeTab={activeTab} overlay={overlay}>
        {children}
      </DesktopShell>
    );
  }

  return (
    <div className="stage">
      <div className="phone">
        <header className="phone-topbar">
          <AppHeader />
        </header>
        <main className="phone-screen">{children}<HomeFooter /></main>
        <TabBar active={activeTab} onMenu={() => setMenuOpen(true)} />
        <MenuScreen open={menuOpen} onClose={() => setMenuOpen(false)} />
        {slipOpen && <BetSlipSheet open={slipOpen} onClose={() => setSlipOpen(false)} />}
        <SupportChat />
        <BetSlipFab count={betCount} onClick={() => setSlipOpen(true)} />
        {overlay}
        <SearchOverlay />
      </div>
    </div>
  );
}
